import { IsNotEmpty, MaxLength, IsString, IsOptional, IsArray, MinLength } from 'class-validator';
import { TeamAccessEditDTO } from '../team/team-access-edit.dto';

export class ProductEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    itemNumber: string;

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    groups: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    manuscripts: Array<string>;

}
